export const getElementScrollInfo = (scrollElement: HTMLElement) => {
    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    const scrollableHeight = scrollHeight - clientHeight;
    const isScrolledToBottom = Math.round(scrollableHeight) === Math.round(scrollTop);

    return {
        scrollHeight,
        scrollTop,
        scrollableHeight,
        isScrolledToBottom,
    };
};
